/** @typedef {import('./AgentDownloadDialog').WizardSelectionsRef} WizardSelectionsRef */

import GetAppIcon from '@material-ui/icons/GetApp';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { Trans } from '@lingui/macro';
import { usePlmPath } from '../../../utilities/PgmUtilities';
import {
    AGENT_OS_WINDOWS,
    AGENT_VIRTUAL_2K_MODEL,
    AGENT_VIRTUAL_3K_MODEL,
    AGENT_VIRTUAL_290_MODEL,
} from './AgentConstants';
import NgpCopyToClipboard from '../../form/NgpCopyToClipboard';
import { useIsDarkMode } from '../../../stores/SessionStore';

import NgpFormButton from '../../form/NgpFormButton';
import { useHelpUrl } from '../../../utilities/HelpUtilities';

const DOWNLOAD_FILENAMES = {
    [AGENT_OS_WINDOWS]: {
        [AGENT_VIRTUAL_2K_MODEL]: 'nPointInstall2000.exe',
        [AGENT_VIRTUAL_3K_MODEL]: 'nPointInstall3000.exe',
        [AGENT_VIRTUAL_290_MODEL]: 'nPointInstall290.exe',
    },
};

const useStyles = makeStyles((theme) => ({
    listItem: {
        marginBottom: theme.spacing(1),
    },
}));

/** @param {import('./AgentDownloadDialog').WizardProps} props */
export default function AgentDownloadInstallWindows({ wizardSelections, primaryXmsLocation }) {
    const classes = useStyles();
    const agentHelpDocUrl = useHelpUrl('InstallingVirtualnPoints');
    const [isDarkMode] = useIsDarkMode();

    const { os, model } = wizardSelections.current;

    const installerFileName = DOWNLOAD_FILENAMES[os][model];
    const installerLocation = usePlmPath(`/${installerFileName}`);

    return (
        <>
            <li className={classes.listItem}>
                <Trans>Download the</Trans>
                <NgpFormButton
                    href={installerLocation}
                    download={installerFileName}
                    startIcon={<GetAppIcon />}
                    variant="outlined"
                    color={isDarkMode ? 'secondary' : 'primary'}
                    container={<Box component="span" ml={1} />}
                >
                    <Trans>nPoint Installer</Trans>
                </NgpFormButton>
            </li>
            <li>
                <Trans>
                    Run the downloaded installer and enter the following value when prompted for the Server Location
                    <Box mb={1.5} />
                    <NgpCopyToClipboard value={primaryXmsLocation} inputProps={{ size: 75 }} />
                </Trans>
            </li>
            <Box mt={1.5} mb={2}>
                <Typography variant="caption" gutterBottom>
                    <Trans>Check the</Trans>{' '}
                    <a target="_blank" rel="noreferrer" href={agentHelpDocUrl}>
                        Help Center
                    </a>{' '}
                    <Trans>for unattended install instructions</Trans>
                </Typography>
            </Box>
        </>
    );
}
